import React, { CSSProperties } from 'react';

interface MicrophoneProps {
    fill?: string;
    secondaryfill?: string;
    width?: string | number;
    height?: string | number;
    style?: CSSProperties;
    className?: string;
}

const Microphone: React.FC<MicrophoneProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
    return (
        <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
            <g fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50">
                <line x1="422.5" y1="842.5" x2="637.5" y2="842.5" />
                <path d="M319.3 467.5s-52.7 281.2 210.7 281.2v93.8" />
                <path d="M740.7 467.5s52.7 281.3-210.7 281.2v93.8" />
                <rect x="422.5" y="217.5" width="215" height="437.5" rx="107.5" ry="107.5" />
            </g>
        </svg>
    );
};

export default Microphone;
